module.exports = __webpack_public_path__ + "static/img/our-people-we-live-full-img2.35ec7ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-we-live-full-img2.jpg
// module id = DTWJ
// module chunks = 0